<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span>Team</span>
                            <div>List View</div>
                        </div>
                    </div>
                    <div class="d-flex mx-4 mt-3" style="flex-grow: 1;position: relative;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="search_key" v-debounce:500ms="searchTeams" debounce-events="input" placeholder="Search by Team Name, Team Email ID" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                    <!-- :disabled="selectedTeams.length == 0" :class="selectedTeams.length ? 'btn-new-danger' : 'btn-new-grey'" -->
                    <button v-if="teamLogin == 'My Team'" class="btn btn-new-danger btn-wide px-6 mr-4 mt-3"  :class="selectedTeams.length ? 'btn-new-danger' : 'btn-new-grey'" :disabled="selectedTeams.length == 0 || disableDelete == true" @click="deleteTeamData"> - Delete</button>
                    <button v-if="teamLogin == 'My Team' && userPermissions.teams.permitted_actions.create" class="btn btn-new-primary btn-wide px-6 mr-4 mt-3" :disabled="selectedTeams.length > 1 || selectedTeams.length < 1" @click="addMember()">Add Member</button>
                    <button v-if="teamLogin == 'My Team' && userPermissions.teams.permitted_actions.create" class="btn btn-new-green btn-wide px-6 mt-3" @click="createTeam()">+ Create Team</button>
                    <el-dropdown trigger="click" class="type-select mt-3 ml-4" >
                        <span class="el-dropdown-link d-flex justify-content-between w-100 px-3">
                            {{teamLogin}} <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey-full.svg" style="margin-right: 4px;margin-left: 18px;">
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="changeTeamMode('My Team')">My Team</el-dropdown-item>
                            <el-dropdown-item @click.native="changeTeamMode('Team Member')">Team Member</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </h2>
            <!-- Dropdown Multiselect Section -->
            <div  class="table-block overflow-x-auto mt-2" style="background-color:#fff;border-top-right-radius:5px" v-if="teams.total > 0">
                <table class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th>My Team</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="table-block overflow-x-auto mt-1" style="background-color:#fff;border-top-right-radius:5px">
                <div class="header-outer" v-if="!ajaxCallInProgress && teams.length == 0">
                    <span class="fw-500" v-if="teamLogin == 'My Team'">My Team</span>
                    <span class="fw-500" v-if="teamLogin == 'Team Member'">Team Member</span>
                </div>
                <!-- Table List View -->
                <table class="team-list-table table-responsive w-100">
                    <thead v-if="!ajaxCallInProgress && teams.length > 0">
                        <tr>
                            <th class="w-1" style="padding: 10px 5px 10px 15px;" v-if="teamLogin == 'My Team'"></th>
                            <th class="w-1" style="padding: 10px 0px 10px 15px;"></th>
                            <th style="padding: 13px 5px 13px 10px;">TEAM NAME</th>
                            <th>CREATED BY</th>
                            <th>TEAM EMAIL ID</th>
                            <th>MEMBERS</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="ajaxCallInProgress">
                            <td colspan="7" class="w-1">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!ajaxCallInProgress && search_key && teams.length == 0" class="text-center font-weight-bold" style="height: 400px;">
                            <td colspan="7" class="w-1 font-weight-bold pb-4 pt-4">
                                <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center"> No Data added!</div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && teams.length == 0" class="text-center font-weight-bold">
                            <td colspan="7" class="w-1 pb-8" style="height: 365px;">
                                <div class="py-15" style="background-color: #e8efff;">
                                    <img src="/static/images/no-team-profile-card.png" alt="" height="130px" width="130px">
                                    <h5 v-if="teamLogin == 'My Team'">Create a Team</h5>
                                    <h5 v-if="teamLogin == 'Team Member'">Team Member list</h5>
                                    <p v-if="teamLogin == 'My Team'">Create and add members to your team</p>
                                    <p v-if="teamLogin == 'Team Member'">Check all the team list you are part of.</p>
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress" v-for="(team, index) in teams" :key="index">
                            <td v-if="teamLogin == 'My Team'" class="w-1" style="padding: 10px 5px 10px 15px;">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" v-model="team.checked" class="custom-control-input" @change="selectOne($event, team, index)"  />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td class="w-1" style="padding: 10px 0px 10px 15px;">
                                <div class="d-flex cards-text">
                                    <div  v-if="!team.logo" class="team-image mr-4">
                                        <span style="text-transform: uppercase;">{{ team.name.split(" ")[0].charAt(0) }}{{ team.name.split(" ").length > 1 ? team.name.split(" ")[1].charAt(0) : "" }}</span>
                                    </div>
                                    <img v-else :src="team.logo" width="30px" height="30px" style="border-radius: 50%;margin-left: -18px;">
                                </div>
                            </td>
                            <td style="padding: 10px 5px 10px 10px;">
                                <div class="overflowing-text" :title="team.name">
                                    <span class="text-secondary pointer" @click="viewTeam(team.id)">{{team.name || "-"}}</span>
                                </div>
                            </td>
                            <td>{{team.created_by_name || "-"}}</td>
                            <td class="overflowing-text w-1" :title="team.email_id">{{ team.email_id || "-"}}</td>
                            <td>
                                {{team.member_count}}
                                <span v-if="team.member_count < 2">Member</span>
                                <span v-else>Members</span>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pl-5 ml-5">
                                    <span class="d-flex align-items-center">
                                        <img v-if="team.members[0]" :src="team.members[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :name="team.members[0].name" style="height:25px;width:25px;border-radius:15px;"/>
                                        <img v-if="team.members[1]" :src="team.members[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :name="team.members[1].name" style="height:25px;width:25px;border-radius:15px;"/>
                                        <img v-if="team.members[2]" :src="team.members[2].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :name="team.members[2].name" style="height:25px;width:25px;border-radius:15px;"/>
                                        <img v-if="team.members[3]" :src="team.members[3].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :name="team.members[3].name" style="height:25px;width:25px;border-radius:15px;"/>
                                        <img v-if="team.members[4]" :src="team.members[4].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :name="team.members[4].name" style="height:25px;width:25px;border-radius:15px;"/></span>
                                        <div class="fw-500 mt-4px text-center text-secondary" v-if="team.member_count > 5">
                                            +{{team.member_count - 5}} more
                                        </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="!ajaxCallInProgress && teams.length > 0" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                    :options="pageLimit" :close-on-select="true" v-model.number="limit"
                    :max-height="210" :allow-empty="false" :searchable="false"
                    open-direction="top" :show-labels="false" placeholder=""
                    style="width: 4.2em !important;padding-right: 10px!important;">
                </multiselect>
                <span class="page-info pr-6 fw-500 text-dark font-size-small">Per page</span>
                <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <create-team v-if="createTeamShow" modal_name="createTeam" @hideCreateTeam="hideCreateTeam" @loadTeams="loadTeams"></create-team>
        <add-member v-if="addMemberShow" :selected_members="selected_members" modal_name="addMember" @hideAddMember="hideAddMember" :selected_team_name="selected_team_name" :selectedTeamData="selectedTeamData" @loadTeams="loadTeams"></add-member>
        <delete-team v-if="deleteTeamShow" modal_name="deleteTeam" @deleteTeam="deleteTeam"  @hideDeleteTeam="hideDeleteTeam" :selectedTeamData="selectedTeamData" :selectedTeamDataDetails="selectedTeamDataDetails"></delete-team>
    </div>
</template>
<script>
import moment from 'moment';
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from '../eventBus/nav-bar-event';
const CreateTeam = () => import("./CreateTeam.vue");
const AddMember = () => import("./AddMemberPopUp.vue");
const DeleteTeam = () => import("./DeleteTeam.vue");
import { SweetModal } from 'sweet-modal-vue';
import teams from "../mixins/teams"
export default {
    data(){
        return{
            disableDelete: false,
            deleteTeamShow: false,
            createTeamShow: false,
            addMemberShow: false,
            ajaxCallInProgress:false,
            teams:[],
            total:0,
            selectedTeams: [],
            skip_temp:0,
            temp_total:0,
            limit: 10,
            count: 0,
            skip:0,
            start: 0,
            end: 0,
            search_key: "",
            pageLimit: [],
            warning_msg:"",
            success_msg:"",
            teamLogin:"My Team",
            selectedTeamData:[],
            selectedTeamDataDetails: [],
            selected_team_name: '',
        }
    },
    mixins:[teams],
    components: {
        CreateTeam,
        AddMember,
        DeleteTeam,
        HalfCircleSpinner,
        SweetModal
    },
    methods:{
        //Clears search input field
        clearSearch(){
            this.search_key = "";
            this.$refs.searchInput.focus();
            this.loadTeams();
        },
        changeTeamMode(mode){
            if(mode != this.teamLogin){
                this.skip = 0
                this.skip_temp = 0
                this.search_key = ""
                this.teamLogin = mode
            }
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            //this.selectedTeams = []
            this.loadTeams();
        },
        createTeam(){
            this.createTeamShow = true;
            setTimeout(() => {
                this.$modal.show("createTeam")
            }, 500);
        },
        hideCreateTeam(){
            this.createTeamShow = false;
        },
        //Opens add members popup
        addMember(){
            this.selected_team_name = this.teams.find(el => el.id == this.selectedTeams[0])
            this.teams.forEach((el, el_index) => {
                if(el.id == this.selected_team_name.id){
                    this.selected_members = el.user_ids
                }
            })
            this.addMemberShow = true;
            setTimeout(() => {
                this.$modal.show("addMember")
            }, 500);
        },
        hideAddMember(){
            this.addMemberShow = false;
        },
        deleteTeamData(){
            if(this.selectedTeams.length >= 1){
                this.disableDelete = true;
                this.deleteTeamShow = true;
                setTimeout(() => {
                    this.$modal.show("deleteTeam")
                }, 500);
                setTimeout(() => {
                    this.disableDelete = false;
                }, 1500);
            }

        },
        hideDeleteTeam(){
            this.deleteTeamShow = false;
        },
        //API call to search teams
        async searchTeams() {
            this.ajaxCallInProgress = true;
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            this.selectedTeams = []
            let params = {
                search_key: this.search_key,
                skip: this.skip,
                limit: this.limit

            }
            if(this.teamLogin == 'My Team'){
                params.role = "owner"
            } else {
                params.role = "member"
            }
            let response = await this.ListTeams(params);
            this.teams = response.response
            this.total = response.count
            setTimeout(() => {
                this.ajaxCallInProgress = false;
            }, 1000);
        },
        //API call to get all teams data
        async loadTeams() {
            //this.search_key = ""
            this.teams = []
            //this.selectedTeams = []
            this.ajaxCallInProgress = true
            let response
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_key
            }
            if(this.teamLogin == 'My Team'){
                params.role = "owner"
            } else {
                params.role = "member"
            }
            response = await this.ListTeams(params);
            this.teams = response.response
            this.total = response.count
            this.teams.forEach((per_cont, per_cont_index) => {
                this.teams[per_cont_index].checked = false;
                if(this.selectedTeams.length){
                    this.selectedTeams.forEach((selected, selected_index) => {
                        if(selected === per_cont.id){
                            this.teams[per_cont_index].checked = true;
                        }
                    })
                }
            })
            this.ajaxCallInProgress = false
        },
        //Select single checkbox method
        selectOne(event, team, team_index) {
            this.selectedTeamData = team
            if(event.target.checked){
                this.selectedTeams.push(team.id)
            } else {
                this.selectedTeams.forEach((selected, selected_team_index) => {
                    if(selected === team.id){
                        this.selectedTeams.splice(selected_team_index, 1)
                    }
                })
            }     
        },
        //Redirects to view team page
        viewTeam(id) {
            this.$router.push('/teams/ViewTeam/' + id);
        },
        //API call to delete selected team
         async deleteTeam() {
            let params = {
                ids:this.selectedTeams
            }
            let response = await this.DeleteTeamDataById("delete",params);
            if (response.status_id == 1) {
                this.$modal.hide("deleteTeam");
                this.selectedTeams = [];
                setTimeout(() => {
                    this.loadTeams();
                }, 500);

            }
        },
        //Pagination methods
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            //this.selectedTeams = []
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.loadTeams();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            this.temp_total = this.skip_temp
            if (this.skip_temp >= this.total) {
                return;
            }
            //this.selectedTeams = []
            this.skip = this.skip_temp;
            this.loadTeams();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            //this.selectedTeams = []
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.loadTeams();
        },
    },
    mounted(){
         EventBus.$on("teams", () => {
            this.createTeamShow = true
            setTimeout(() => {
                this.$modal.show("createTeam")
            }, 500);
        })
        this.loadTeams();
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.teamLogin = "My Team"
    },
    created() {
        this.createTeamShow = this.$route.params.teams
        setTimeout(() => {
            this.$modal.show("createTeam")
        }, 500);
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    watch: {
        teamLogin: function() {
            this.loadTeams();
        },
        limit: function(){
            this.loadTeams();
        },
    },
}
</script>
<style scoped>
    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: auto;
    }
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .empty-tbody{
        height: 410px;
        display: block;
        background-color: #E8EFFF;
        margin: 20px;
        text-align: center;
        padding-top:60px;
    }
    .pointer{
        cursor: pointer !important;
    }
    .cards-text {
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .team-image {
        color: #fff;
        font-weight: 500;
        font-size: 15px;
        background: #091e42;
        border-radius: 50%;
        width: 33px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-icon{
        width: 36px;
        margin-left: -12px;
    }
    .overflowing-text{
        max-width:220px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .header-outer {
        width: 100%;
        background: #00448b;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: left;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Teams/TeamListView.vue